export const V2_RECAPTCHA_CONTAINER_ID = "recaptcha-v2-container";

export const V2Recaptcha = () => {
  return <div id={V2_RECAPTCHA_CONTAINER_ID}></div>;
};
